import { render, staticRenderFns } from "./detailDisabilitas.vue?vue&type=template&id=2e3cc6eb"
import script from "./detailDisabilitas.vue?vue&type=script&lang=js"
export * from "./detailDisabilitas.vue?vue&type=script&lang=js"
import style0 from "./detailDisabilitas.vue?vue&type=style&index=0&id=2e3cc6eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports